module.exports = {
    input: {
        volume: "volume",
        surfaces: "surfaces",
        textiles: "textiles",
    }
}